var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"video-wall",on:{"click":function($event){_vm.show = false}}},[_c('videoPlayer',{ref:"videoPlayer",staticClass:"video",style:({
      width: _vm.isDesktop ? '50vw' : '100vw'
    }),attrs:{"options":_vm.playerOptions},on:{"onError":_vm.onError},nativeOn:{"click":function($event){$event.stopPropagation();}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }